export const productCategories = {
	ANALYZER_MONOPHASE: 'J',
	ANALYZER_THREE_PASE: 'K',
	ANALYZER_MONOPHASE_V2: 'V',
	ANALYZER_THREE_PASE_V2: 'W',
	HUB: 'Q',
	WALLBOX_MONOPHASE: 'X',
	WALLBOX_THREE_PHASE: 'Y',
};
